export default __webpack_public_path__ + "static/media/mana.dc8e4180.svg";